// The lesson-action artwork, keyed by action name. LessonActionIcon draws the
// action beside a clue's prompt; lesson content can also name one as a clue's
// own icon ('action:sniff'), which lessonIcons.js resolves through this map.
import look from '../assets/lesson-actions/rim.webp';
import rim from '../assets/lesson-actions/inspect-rim.webp';
import colour from '../assets/lesson-actions/colour.webp';
import sniff from '../assets/lesson-actions/sniff.webp';
import taste from '../assets/lesson-actions/taste.webp';
import swirl from '../assets/lesson-actions/swirl.webp';
import label from '../assets/lesson-actions/label.webp';
import map from '../assets/lesson-actions/map.webp';
import compare from '../assets/lesson-actions/compare.webp';
import timer from '../assets/illustrations/timer.webp';
import single from '../assets/illustrations/single.webp';
import vintage from '../assets/illustrations/wine-vintage.webp';
import budget from '../assets/illustrations/wine-budget.webp';

export const LESSON_ACTION_IMAGES = Object.freeze({ look, rim, colour, sniff, taste, swirl, label, map, compare, timer, single, vintage, budget });

export default LESSON_ACTION_IMAGES;
